import React from "react";
import AppRouter from "../src/routes/AppRouter";
import '@fontsource/nunito';


function App() {
    return <AppRouter />
}

export default App;
